import React from "react";
import { Form, FormField, Input, Button, SpaceBetween, Checkbox, Grid } from "@cloudscape-design/components";
import { RealmSelector } from "../common";
import { Realm, Stage, LABELS } from "../../constants";

interface SearchFormProps {
  customerId: string;
  realm: Realm;
  stage: Stage;
  includeHistory: boolean;
  loading: boolean;
  onCustomerIdChange: (value: string) => void;
  onRealmChange: (realm: Realm) => void;
  onHistoryChange: (checked: boolean) => void;
  onSearch: () => void;
}

export const SearchForm: React.FC<SearchFormProps> = ({
  customerId,
  realm,
  stage,
  includeHistory,
  loading,
  onCustomerIdChange,
  onRealmChange,
  onHistoryChange,
  onSearch,
}) => {
  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    onSearch();
  };

  return (
    <form onSubmit={handleSubmit}>
      <Form
        actions={
          <Button variant="primary" loading={loading}>
            {LABELS.SEARCH}
          </Button>
        }
      >
        <SpaceBetween size="m">
          <Grid gridDefinition={[{ colspan: 8 }, { colspan: 4 }]}>
            <FormField label={LABELS.CUSTOMER_ID}>
              <Input value={customerId} onChange={(e) => onCustomerIdChange(e.detail.value)} placeholder={LABELS.CUSTOMER_ID_PLACEHOLDER} />
            </FormField>
            <FormField label={LABELS.REALM}>
              <RealmSelector value={realm} stage={stage} onChange={onRealmChange} />
            </FormField>
          </Grid>
          <Checkbox checked={includeHistory} onChange={(e) => onHistoryChange(e.detail.checked)}>
            {LABELS.INCLUDE_HISTORY}
          </Checkbox>
        </SpaceBetween>
      </Form>
    </form>
  );
};
